// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-home:hover::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumbActive);
  border: 6px solid transparent;
}
.page-home::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.page-home {
  overflow: hidden;
  position: relative;
  color: var(--color-text);
}
.page-home .bg-img {
  width: 100%;
  height: 100%;
  background-size: cover;
  opacity: 0.1;
  mask-image: linear-gradient(to top, white 10%, black calc(75% + 1px), black 100%);
}
.page-home .home-title {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.page-home .home-title .title-text {
  font-family: Ubuntu-R, sans-serif;
  font-size: 83px;
  -webkit-user-select: none;
          user-select: none;
}
.page-home .home-title .title-subText {
  font-family: Ubuntu-R, sans-serif;
  font-size: 17px;
  -webkit-user-select: none;
          user-select: none;
}
.page-home .home-counter {
  position: absolute;
  top: 56%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10%;
}
.page-home .home-counter .counter-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.page-home .home-counter .counter-item .item-count {
  height: 84px;
  width: 84px;
  display: flex;
  background: rgba(255, 255, 255, 0.0784313725);
  border: 1px solid #5d5d5d;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 24px;
  font-family: Ubuntu-M, sans-serif;
  color: #6c50a5;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: rgba(50, 50, 93, 0.15) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 26px -8px inset;
}
.page-home .home-counter .counter-item .item-title {
  font-family: Ubuntu-M, sans-serif;
  font-size: 24px;
  -webkit-user-select: none;
          user-select: none;
  color: var(--color-secondText);
  text-align: center;
}

@media (max-width: 599px) {
  .page-home .home-title {
    top: 4%;
  }
  .page-home .home-counter {
    top: 24%;
    flex-direction: column;
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/scrollbar.scss","webpack://./src/pages/home/home.scss","webpack://./src/theme/responsiv.scss"],"names":[],"mappings":"AAwBE;EACE,oDAAA;EACA,6BAAA;ACvBJ;AD0BE;EACE,mDAAA;ACxBJ;;AAHA;EACE,gBAAA;EACA,kBAAA;EACA,wBAAA;AAMF;AAJE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,iFAAA;AAMJ;AAHE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAKJ;AAHI;EACE,iCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAKN;AAFI;EACE,iCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAIN;AACE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACN;AACM;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,6CAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,iCAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,yGAAA;AADR;AAIM;EACE,iCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8BAAA;EACA,kBAAA;AAFR;;ACjFI;EDgGA;IACE,OAAA;EAXJ;EAcE;IACE,QAAA;IACA,sBAAA;IACA,SAAA;EAZJ;AACF","sourcesContent":["%scrollbar {\n  /* custom scrollbar */\n  &::-webkit-scrollbar {\n    width: 12px;\n    -webkit-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    -moz-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumb);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}\n\n%scrollbarHover {\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumbActive);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}","@import '../../theme/scrollbar.scss';\n@import '../../theme/responsiv.scss';\n\n.page-home {\n  overflow: hidden;\n  position: relative;\n  color: var(--color-text);\n\n  .bg-img {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    opacity: 0.1;\n    mask-image: linear-gradient(to top, white 10%, black calc(75% + 1px), black 100%);\n  }\n\n  .home-title {\n    position: absolute;\n    top: 30%;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    .title-text {\n      font-family: Ubuntu-R, sans-serif;\n      font-size: 83px;\n      user-select: none; \n    }\n\n    .title-subText {\n      font-family: Ubuntu-R, sans-serif;\n      font-size: 17px;\n      user-select: none; \n    }\n  }\n\n\n  .home-counter {\n    position: absolute;\n    top: 56%;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10%;\n\n    .counter-item {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 10px;\n\n      .item-count {\n        height: 84px;\n        width: 84px;\n        display: flex;\n        background: #ffffff14;\n        border: 1px solid #5d5d5d;\n        align-items: center;\n        justify-content: center;\n        border-radius: 100%;\n\n        font-size: 24px;\n        font-family: Ubuntu-M, sans-serif;\n        color: #6c50a5;\n        user-select: none; \n\n        box-shadow: rgba(50, 50, 93, 0.15) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 26px -8px inset;\n      }\n\n      .item-title {\n        font-family: Ubuntu-M, sans-serif;\n        font-size: 24px;\n        user-select: none;\n        color: var(--color-secondText);\n        text-align: center;\n      }\n    }\n  }\n\n}\n\n.page-home:hover {\n  @extend %scrollbarHover;\n}\n\n@include appSize(phone-only) {    \n  .page-home  {\n    .home-title {\n      top: 4%;\n    }\n\n    .home-counter {\n      top: 24%;\n      flex-direction: column;\n      gap: 20px;\n    }\n  }\n}","@mixin appSize($size) {\n  @if $size == phone-only {\n    @media (max-width: 599px) { @content; }\n  } @else if $size == tablet-portrait-up {\n    @media (min-width: 600px) { @content; }\n  } @else if $size == tablet-landscape-up {\n    @media (min-width: 900px) { @content; }\n  } @else if $size == desktop-up {\n    @media (min-width: 1200px) { @content; }\n  } @else if $size == big-desktop-up {\n    @media (min-width: 1800px) { @content; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
